/**
 * `futurex permissions [show|set <kind> <ask|allow|deny>|reset]` and the REPL's
 * `/permissions` — view, change, and revoke the project's persistent per-kind
 * consent (see permissions.ts). `show` is the default.
 */
import { ACTION_KINDS } from '@fim/futurex-tools';
import {
  describePermissions,
  parseActionKind,
  parseConsent,
  resetProjectPermissions,
  setConsent,
} from './permissions.js';
import { color, error, info, line } from './ui.js';

export function runPermissions(root: string, rest: string): void {
  const [sub = 'show', ...args] = rest.trim().split(/\s+/).filter(Boolean);

  switch (sub.toLowerCase()) {
    case 'show':
    case '': {
      info(`permissions for ${root} (stored in ~/.futurex/permissions.json)`);
      for (const lineText of describePermissions(root)) line(`  ${lineText}`);
      line(color.dim('  change: permissions set <kind> <ask|allow|deny> · revoke all: permissions reset'));
      return;
    }
    case 'reset': {
      resetProjectPermissions(root);
      info('permissions reset — every action kind will ask again');
      return;
    }
    case 'set': {
      const kind = args[0] !== undefined ? parseActionKind(args[0]) : undefined;
      const consent = args[1] !== undefined ? parseConsent(args[1]) : undefined;
      if (!kind || !consent) {
        error(`usage: permissions set <${ACTION_KINDS.join('|')}> <ask|allow|deny>`);
        return;
      }
      setConsent(root, kind, consent);
      info(`${kind} → ${consent === 'ask' ? 'ask each time' : `always ${consent}`}`);
      return;
    }
    default:
      error(`unknown subcommand "${sub}" (expected: show | set | reset)`);
  }
}
